import { useContext } from "react"

import { CampaignFormContext } from "pages/campaigns/campaignForm/campaignForm.context"
import UpdateCampaignForm from "./components/updateCampaignForm/updateCampaignForm"
import CreateCampaignForm from "./components/createCampaignForm/createCampaignForm"

const CampaignFormSteps = () => {
  const { updateCampaignId } = useContext(CampaignFormContext)

  return <>{updateCampaignId ? <UpdateCampaignForm /> : <CreateCampaignForm />}</>
}

export default CampaignFormSteps
